export type LinkItem = {
  id: string
  label: string
  url: string
  icon: string
  badge?: 'novo' | 'quente' | 'limited' | 'em-breve'
  badgeLabel?: string
  tracking?: Record<string, string>
  category: 'shop' | 'launch' | 'character' | 'tiktok' | 'newsletter' | 'contact' | 'social'
  external?: boolean
  enabled?: boolean
}

export const linksConfig: LinkItem[] = [
  {
    id: 'shop',
    label: 'Loja Oficial',
    url: 'https://squibbles.com/shop',
    icon: '🛍️',
    badge: 'quente',
    badgeLabel: 'NOVO',
    category: 'shop',
    tracking: { utm_source: 'instagram_bio', utm_medium: 'link_in_bio', utm_campaign: 'shop' },
  },
  {
    id: 'lancamentos',
    label: 'Lançamentos',
    url: 'https://squibbles.com/lancamentos',
    icon: '✨',
    badge: 'novo',
    badgeLabel: 'HOJE',
    category: 'launch',
    tracking: { utm_source: 'instagram_bio', utm_medium: 'link_in_bio', utm_campaign: 'launch' },
  },
  {
    id: 'personagens',
    label: 'Conheça os Personagens',
    url: 'https://squibbles.com/personagens',
    icon: '🎭',
    category: 'character',
    tracking: { utm_source: 'instagram_bio', utm_medium: 'link_in_bio', utm_campaign: 'characters' },
  },
  {
    id: 'tiktok-shop',
    label: 'TikTok Shop',
    url: 'https://tiktok.com/@squibbles/shop',
    icon: '🎵',
    badge: 'limited',
    badgeLabel: 'EXCLUSIVO',
    category: 'tiktok',
    external: true,
    tracking: { utm_source: 'instagram_bio', utm_medium: 'link_in_bio', utm_campaign: 'tiktok_shop' },
  },
  {
    id: 'newsletter',
    label: 'Newsletter VIP',
    url: 'https://squibbles.com/newsletter',
    icon: '💌',
    badge: 'em-breve',
    badgeLabel: 'EM BREVE',
    category: 'newsletter',
    tracking: { utm_source: 'instagram_bio', utm_medium: 'link_in_bio', utm_campaign: 'newsletter' },
  },
  {
    id: 'contato',
    label: 'Fale Conosco',
    url: 'https://squibbles.com/contato',
    icon: '💬',
    category: 'contact',
    tracking: { utm_source: 'instagram_bio', utm_medium: 'link_in_bio', utm_campaign: 'contact' },
  },
  {
    id: 'instagram',
    label: '@squibbles',
    url: 'https://instagram.com/squibbles',
    icon: '📸',
    category: 'social',
    external: true,
  },
  {
    id: 'tiktok',
    label: '@squibbles',
    url: 'https://tiktok.com/@squibbles',
    icon: '🎵',
    category: 'social',
    external: true,
  },
]